import { useLayoutEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { TollFreeAddNumberRoutesSteps } from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { usePathSegment } from 'pages/settings/pages/compliance/hooks/usePathSegment'

export const TollFreeAddNumberAccessLayout = observer(() => {
  const store = useTollFreeStepsContext()

  const lastPathSegment = usePathSegment<TollFreeAddNumberRoutesSteps>()
  const noRedirect = lastPathSegment === TollFreeAddNumberRoutesSteps.Numbers

  useLayoutEffect(() => {
    if (noRedirect) return

    uiStore.changeRouteViaVue({
      method: 'replace',
      path: store.tollFreeAddNumberNavigationStore.getCurrentUrl,
    })
  }, [])

  return <Outlet />
})
